"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  OfficeOutdoors: ['office-outdoors', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.598 23.25L7.598 19.337', 'M13.467 23.25L13.467 19.337', 'M5.641 19.337L15.424 19.337', 'M.75,23.25V6.958A1.007,1.007,0,0,1,1.8,6h8.4a1.007,1.007,0,0,1,1.05.958V15.75', 'M8.25,3.5A.534.534,0,0,0,7.688,3H4.313a.534.534,0,0,0-.563.5V6h4.5Z', 'M5.977 2.706L6 0.913', 'M3.75 9.75L8.25 9.75', 'M3.75 14.25L8.25 14.25', 'M0.75 23.25L23.25 23.25', 'M15.750 12.750 A3.750 3.750 0 1 0 23.250 12.750 A3.750 3.750 0 1 0 15.750 12.750 Z', 'M19.5 23.25L19.5 13.5']],
  OfficeEmployee: ['office-employee', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.931,23.25H6.069L4.527,16.281a1.139,1.139,0,0,1,.166-.885.881.881,0,0,1,.72-.4H18.587a.881.881,0,0,1,.72.4,1.139,1.139,0,0,1,.166.885Z', 'M0.75 23.25L23.25 23.25', 'M10.500 18.750 A1.500 1.500 0 1 0 13.500 18.750 A1.500 1.500 0 1 0 10.500 18.750 Z', 'M8.445,2.781a6.848,6.848,0,0,0,4.93,2.094,6.851,6.851,0,0,0,2.713-.558', 'M7.875 4.875 A4.125 4.125 0 1 0 16.125 4.875 A4.125 4.125 0 1 0 7.875 4.875 Z', 'M17,12.75a6.676,6.676,0,0,0-10,0']],
  OfficeDesk2: ['office-desk-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 23.238L0.75 14.238', 'M14.25,14.238h9a0,0,0,0,1,0,0v8.5a.5.5,0,0,1-.5.5h-8a.5.5,0,0,1-.5-.5v-8.5A0,0,0,0,1,14.25,14.238Z', 'M1.25,11.238h21.5a.5.5,0,0,1,.5.5v2.5a0,0,0,0,1,0,0H.75a0,0,0,0,1,0,0v-2.5A.5.5,0,0,1,1.25,11.238Z', 'M14.25 18.738L23.25 18.738', 'M3.750 0.738 L15.750 0.738 L15.750 8.238 L3.750 8.238 Z', 'M9.75 8.238L9.75 11.238']],
  OfficeChairTable: ['office-chair-table', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 21.75L0.75 8.25', 'M15.75,11.25h7.5a0,0,0,0,1,0,0v7.5a0,0,0,0,1,0,0h-7a.5.5,0,0,1-.5-.5v-7A0,0,0,0,1,15.75,11.25Z', 'M15.75,11.25h7.5V9a.75.75,0,0,0-.75-.75H15.75', 'M23.25 18.75L23.25 21.75', 'M19.5,14.625a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375', 'M12.75,21.75v-15a4.5,4.5,0,0,0-9,0v15', 'M3.75 15.75L12.75 15.75']],
  OfficeChairTable1: ['office-chair-table-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.25,7.5V6.75a3.75,3.75,0,0,1,7.5,0V7.5', 'M8.25 16.5L8.25 21.001', 'M15.75 16.5L15.75 21.001', 'M0.75 10.5L23.25 10.5', 'M3.75 10.5L3.75 21', 'M20.25 10.5L20.25 21', 'M15.75,16.5a1.5,1.5,0,0,0,0-3H8.25a1.5,1.5,0,0,0,0,3Z']],
  OfficeDeskLamp: ['office-desk-lamp', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.468,16.5H1.562a.751.751,0,0,1-.681-1.065L4.89,6.75H19.14l4.009,8.685A.751.751,0,0,1,22.468,16.5Z', 'M3.061 23.25L5.311 16.5 7.561 23.25', 'M16.561 23.25L18.811 16.5 21.061 23.25', 'M16.14 13.5L14.64 9.75 9.39 9.75 7.89 13.5', 'M19.14,6.75v-3a3,3,0,0,0-3-3H10.561a1.5,1.5,0,0,0-1.5,1.5v1.5h6v-3']],
  OfficeDrawingBoard: ['office-drawing-board', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.586,12.75H3.376a.751.751,0,0,1-.7-1.014L6.428,1.723A1.5,1.5,0,0,1,7.833.75h13.21a.75.75,0,0,1,.7,1.013L17.99,11.776A1.5,1.5,0,0,1,16.586,12.75Z', 'M3.7 9L19.031 9', 'M20.625 4.75L20.625 23.25', 'M19.125 23.25L22.125 23.25', 'M10.125,19.5a1.5,1.5,0,0,1,0-3h3.75a1.5,1.5,0,0,1,0,3Z', 'M10.125 19.5L9.375 23.25', 'M13.875 19.5L14.625 23.25', 'M3.375 23.25L3.376 15', 'M1.875 23.25L4.875 23.25']],
  OfficeTableCabinets: ['office-table-cabinets', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.5 13.5L23.25 13.5 23.25 14.445', 'M16.5,22.275a.973.973,0,0,0,.964.975h4.822a.973.973,0,0,0,.964-.975V13.5H16.5Z', 'M10.5,11.511v4.532A1.962,1.962,0,0,1,8.544,18H5.25', 'M.75,23.25V14.478a.981.981,0,0,1,.978-.978H7.109', 'M23.25,13.467V1.728A.974.974,0,0,0,22.286.75H16.5V13.467', 'M9 0.75L9 8.25', 'M7.5 18L7.5 23.25', 'M6 23.25L9 23.25', 'M0.75 0.75H16.5V8.25H0.75z', 'M4.125,4.5a.375.375,0,1,1-.375.375A.375.375,0,0,1,4.125,4.5', 'M12.375,4.5A.375.375,0,1,1,12,4.875a.375.375,0,0,1,.375-.375', 'M19.875,9.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M19.875,19.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  OfficeWorkWireless: ['office-work-wireless', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 7.500 A2.250 2.250 0 1 0 6.750 7.500 A2.250 2.250 0 1 0 2.250 7.500 Z', 'M9.751,23.25a1.5,1.5,0,0,1-1.343-.829l-.671-1.342A1.491,1.491,0,0,0,6.4,20.25H4.5A1.5,1.5,0,0,1,3,18.75v-6A1.5,1.5,0,0,1,5.332,11.5l1.116.744a3,3,0,0,0,1.664.5H9.75a1.5,1.5,0,0,1,0,3H8.112A5.985,5.985,0,0,1,6,15.366V17.25h.4a4.477,4.477,0,0,1,4.025,2.487l.671,1.342A1.5,1.5,0,0,1,9.751,23.25Z', 'M4.5 20.25L1.5 20.25', 'M9.75 15.75L20.25 15.75', 'M15 15.75L15 23.25', 'M14.25 12.75L20.25 12.75 22.5 7.5', 'M14.25,7.125a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M11.6,4.848a3.752,3.752,0,0,1,5.3,0', 'M9.477,2.727a6.75,6.75,0,0,1,9.546,0', 'M3.75 23.25L3.75 20.25']],
  OfficeChairTable2: ['office-chair-table-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,20.249V11.871a1.5,1.5,0,0,0-.439-1.061L20.689,8.689a1.5,1.5,0,0,0-1.06-.44H4.371a1.5,1.5,0,0,0-1.06.44L1.189,10.81A1.5,1.5,0,0,0,.75,11.871v8.378', 'M4.5 11.249L19.5 11.249', 'M8.25,8.249V7.5a3.75,3.75,0,0,1,7.5,0v.75', 'M8.25 11.249L8.25 20.249', 'M15.75 11.249L15.75 20.249', 'M6.75,14.249a10.376,10.376,0,0,0,5.25,1.5,10.376,10.376,0,0,0,5.25-1.5']],
  OfficeOutdoors1: ['office-outdoors-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 4.5L11.25 4.5', 'M0.75 8.25L11.25 8.25', 'M2.25 12H9.75V23.25H2.25z', 'M0.75 23.25L23.25 23.25', 'M4.5 15H7.5V18H4.5z', 'M20.25 23.25L15.75 23.25 15 19.5 21 19.5 20.25 23.25z', 'M18 19.5L18 13.5', 'M0.750 0.750 L11.250 0.750 L11.250 12.000 L0.750 12.000 Z', 'M15.751,16.536a6.183,6.183,0,0,1-2.1-4.861C13.646,8.541,15.6,6,18,6s4.354,2.541,4.354,5.675a6.183,6.183,0,0,1-2.1,4.86', 'M5.25 20.25L6.75 20.25']],
  OfficeTable: ['office-table', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 20.25L0.75 6.75', 'M14.25 6.75H23.25V11.25H14.25z', 'M14.25 11.25H23.25V15.75H14.25z', 'M14.25,15.75h9a0,0,0,0,1,0,0v4a.5.5,0,0,1-.5.5h-8a.5.5,0,0,1-.5-.5v-4a0,0,0,0,1,0,0Z', 'M1.25,3.75h21.5a.5.5,0,0,1,.5.5v2.5a0,0,0,0,1,0,0H.75a0,0,0,0,1,0,0V4.25A.5.5,0,0,1,1.25,3.75Z']],
  OfficeDesk: ['office-desk', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.991 0.750 L14.991 0.750 L14.991 9.750 L2.991 9.750 Z', 'M21.949,15.335a.751.751,0,0,1-.671.415H2.705a.751.751,0,0,1-.671-.415l-.75-1.5a.75.75,0,0,1,.671-1.085H22.028a.75.75,0,0,1,.671,1.085Z', 'M5.241 15.75L2.991 23.25 4.491 23.25 8.991 15.75', 'M18.741 15.75L20.991 23.25 19.491 23.25 14.991 15.75', 'M2.991 6.75L14.991 6.75', 'M7.491 9.75L6.741 12.75', 'M10.491 9.75L11.241 12.75', 'M17.991 9.75H20.991V12.75H17.991z', 'M19.491 9.75L20.991 6']],
  OfficeChair: ['office-chair', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18,14.25a1.5,1.5,0,0,1-1.5,1.5h-9a1.5,1.5,0,0,1,0-3h9A1.5,1.5,0,0,1,18,14.25Z', 'M12 15.75L12 23.25', 'M5.463,23.25A6.658,6.658,0,0,1,12,18.75a6.66,6.66,0,0,1,6.537,4.5', 'M3,9.75v3a3,3,0,0,0,3,3H7.5', 'M1.5 9.75L4.5 9.75', 'M21,9.75v3a3,3,0,0,1-3,3H16.5', 'M22.5 9.75L19.5 9.75', 'M16.5,5.25a4.5,4.5,0,0,0-9,0v7.5h9Z']]
};
exports["default"] = _default;